import styled from 'foundations-theming/utils';
import { trellisBreakpoint } from 'pricing-pages-ui-components/constants/Breakpoints';
export const MerchCardWrapper = styled.div.withConfig({
  displayName: "MerchCardSharedComponents__MerchCardWrapper",
  componentId: "sc-1pwleyq-0"
})(["display:contents;"]);
export const MerchCardTitleContainer = styled.div.withConfig({
  displayName: "MerchCardSharedComponents__MerchCardTitleContainer",
  componentId: "sc-1pwleyq-1"
})(({
  theme
}) => {
  return {
    display: 'flex',
    alignItems: 'start',
    gap: theme.space[200],
    blockSize: '100%',
    [trellisBreakpoint.sdMac]: {
      flexDirection: 'column',
      justifyContent: 'end'
    }
  };
});